<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <alert-container :messages="msgs" />
            <div class="listing-header mb-3">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t('mao-de-obra-alocada') }}
                    </h1>
                </div>
                <div class="header-buttons">
                    <button class="delete-btn" type="button" @click="onFecharModal">
                        {{ $t('cancelar') }}
                    </button>
                    <button class="save-btn" type="button" @click="save">
                        {{ $t('salvar') }}
                    </button>
                </div>
            </div>
            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-6">
                        <vss-select 
                            :id="generateId(1)"
                            ref="cargoInput"
                            :title="'cargo'"
                            :options="cargos"
                            v-model="assclientemaodeobra.cargo"
                            :search="loadCargos"
                            :onChange="updateCargo"
                            placeholder="placeholder-preencha"
                            :invalid="isNull(assclientemaodeobra.cargo)"
                            :loading="loadingCargo"
                            :dropdownHeight="180"
                            tooltipLabel="msg-pro-cargo"
                            required
                        />
                    </div>
                    <div class="column is-6">
                        <vss-select
                            :id="generateId(2)"
                            ref="tipoCobrancaInput"
                            :searchable="false"
                            placeholder="placeholder-preencha"
                            :options="tipoCobrancaSelect"
                            v-model="assclientemaodeobra.tipoCobranca"
                            mlLabels
                            title="tipo-cobranca"
                            clearable
                            @input="onTipoCobrancaChanged"
                            :invalid="isNull(assclientemaodeobra.tipoCobranca)"
                            required
                        />
                    </div>
                    <div class="column is-6">
                        <vss-select
                            :id="generateId(3)"
                            ref="tipoAlocacaoInput"
                            :searchable="false"
                            placeholder="placeholder-preencha"
                            :options="tipoAlocacaoSelect"
                            v-model="assclientemaodeobra.tipoAlocacao"
                            mlLabels
                            title="tipo-alocacao"
                            clearable
                            @input="onTipoAlocacaoChanged"
                            :invalid="isNull(assclientemaodeobra.tipoAlocacao)"
                            required
                        />
                    </div>
                    <div class="column is-6">
                        <v-money
                            :id="generateId(4)"
                            ref="qtdInput"
                            title="quantidade-colaboradores-contratados"
                            placeholder="placeholder-preencha"
                            :msg="'msg-campo-obrigatorio'"
                            :required="true"
                            :value="assclientemaodeobra.qtde"
                            @input="quantidadeUpdate"
                            :invalid="isNull(assclientemaodeobra.qtde)"
                            :max="9999999"
                            :precision="0"
                            :min="1"
                        />
                    </div>
                    <div class="column is-6">
                        <v-money
                            :id="generateId(5)"
                            ref="valorUnitInput"
                            title="valor-unitario-custo"
                            placeholder="placeholder-preencha"
                            :msg="'msg-campo-obrigatorio'"
                            :required="true"
                            :value="assclientemaodeobra.valorunitariocusto"
                            @input="valUnitUpdate"
                            :invalid="isNull(assclientemaodeobra.valorunitariocusto)"
                            :max="9999999"
                        />
                    </div>
                    <div class="column is-6">
                        <v-money
                            :id="generateId(6)"
                            ref="valorUnitFinalInput"
                            title="valor-unitario-final"
                            placeholder="placeholder-preencha"
                            :msg="'msg-campo-obrigatorio'"
                            :required="true"
                            :value="assclientemaodeobra.valorunitariofinal"
                            @input="valUnitFinalUpdate"
                            :invalid="isNull(assclientemaodeobra.valorunitariofinal)"
                            :max="9999999"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CargoService from '@/services/promotor/cliente/CargoService';
import AssClienteMaoDeObraService from '@/services/promotor/cliente/AssClienteMaoDeObraService';
import MaoObraAlocadaValidation from '@/services/validations/promotor/cliente/MaoObraAlocadaValidation';
import Message from '@/models/Message';
import { mapState } from 'vuex';

export default {
    props: {
        idcliente: 0,
        selected: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            cargoService: new CargoService(this.$http, this.$router),
            service: new AssClienteMaoDeObraService(this.$http, this.$router),
            validation: null,
            isLoading: false,
            msgs: [],
            cargos: [],
            isSaving: false,
            loadingCargo: false,
            tipoCobrancaSelect: [
                { id: 1, key: 'M', label: 'mensal' },
                { id: 2, key: 'D', label: 'diaria' },
                { id: 3, key: 'H', label: 'por-hora' },
            ],
            tipoAlocacaoSelect: [
                { id: 1, key: 'M', label: 'mensal' },
                { id: 2, key: 'A', label: 'avulso' },
            ],
            assclientemaodeobra: {
                idassclientemaodeobra: null,
                cargo: null,
                idcliente: null,
                qtde: 1,
                valorunitariocusto: 0,
                valorunitariofinal: 0,
                tipoCobranca: { id: 1, key: 'M', label: 'mensal' },
                tipoAlocacao: { id: 1, key: 'M', label: 'mensal' },
                situacao: 1,
            },
            isUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
            cargoSelected: null,
        };
    },
    created() {
        this.carregarDados();
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        carregarDados() {
            this.validation = new MaoObraAlocadaValidation(this.msgs);

            this.loadCargos();   
            
            if (this.selected) {
                this.loadMaoObra();
            }
        },
        save() {
            this.isLoading = true;
            let assclientemaodeobraTemp = this.mapOnSave();
            assclientemaodeobraTemp = this.mapTosave(assclientemaodeobraTemp);
            if (this.validation.validate(assclientemaodeobraTemp, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(assclientemaodeobraTemp)
                    .then((value) => {
                        if (value.content) {
                            let msg = this.$t("mao-de-obra-vinculado");
                            this.msgs.push(new Message('success', msg, true, false));
                            this.onFecharModal(2);
                        } else {
                            if (this.$t(value.message)) {
                                let msgErro = this.$t(value.message);
                                this.msgs.push(new Message('error', msgErro, true, false));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true, false)
                                );
                            }
                            this.isSaving = false;
                        }
                    })
                    .catch((e) => {
                        this.$root.showMessage(new Message('error', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.isSaving = false;
                this.isLoading = false;
            }
        },
        mapOnSave() {
            return {
                idcargo: this.isNull(this.assclientemaodeobra.cargo)
                    ? null
                    : this.assclientemaodeobra.cargo.id,
                tipoCobranca: this.isNull(this.assclientemaodeobra.tipoCobranca)
                    ? null
                    : this.assclientemaodeobra.tipoCobranca.key,
                tipoAlocacao: this.isNull(this.assclientemaodeobra.tipoAlocacao)
                    ? null
                    : this.assclientemaodeobra.tipoAlocacao.key,

                idassclientemaodeobra: this.assclientemaodeobra.idassclientemaodeobra,
                idcliente: this.idcliente,
                qtde: this.assclientemaodeobra.qtde,
                valorunitariocusto: this.assclientemaodeobra.valorunitariocusto,
                valorunitariofinal: this.assclientemaodeobra.valorunitariofinal,
                situacao: this.assclientemaodeobra.situacao,
            };
        },
        mapMaoObra(val) {
            this.assclientemaodeobra = {
                tipoCobranca: {
                    key: val.tipoCobranca,
                    label:
                        val.tipoCobranca == 'M'
                            ? 'mensal'
                            : val.tipoCobranca == 'D'
                            ? 'diaria'
                            : val.tipoCobranca == 'H'
                            ? 'por-hora'
                            : null,
                },
                tipoAlocacao: {
                    key: val.tipoAlocacao,
                    label:
                        val.tipoAlocacao == 'M'
                            ? 'mensal'
                            : val.tipoAlocacao == 'A'
                            ? 'avulso'
                            : null,
                },
                cargo: {
                    id: val.cargo.idcargo,
                    idcargo: val.cargo.idcargo,
                    label: val.cargo.descricao,
                },
                idassclientemaodeobra: val.idassclientemaodeobra,
                idcliente: val.idcliente,
                qtde: val.qtde,
                valorunitariocusto: val.valorunitariocusto,
                valorunitariofinal: val.valorunitariofinal,
                situacao: val.situacao,
            };
        },
        onTipoCobrancaChanged(val) {
            this.assclientemaodeobra.tipoCobranca = val;
        },
        onTipoAlocacaoChanged(val) {
            this.assclientemaodeobra.tipoAlocacao = val;
        },
        loadMaoObra() {
            this.service
                .find(this.selected.idassclientemaodeobra)
                .then((body) => this.mapMaoObra(body.content))
                .finally(() => {
                    this.isLoading = false;
                });
        },
        loadCargos(search) {
            this.loadingCargo = true;
            const params = search ? this.idcliente + ";" + search : this.idcliente;
            this.cargoService
                .findAllCombo(50, params)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idcargo,
                            label: m.descricao,
                        };
                    });
                })
                .then((allcargos) => {
                    this.cargos = allcargos;
                    this.cargos.sort();
                    if (this.assclientemaodeobra.cargo && this.assclientemaodeobra.cargo) {
                        this.updateCargo(
                            this.cargos.filter(
                                (sg) => sg.obj.idcargo == this.assclientemaodeobra.cargo.idcargo
                            )[0]
                        );
                    }
                }, 350)
                .finally(() => {
                    this.loadingCargo = false;
                });
        },
        updateCargo(cargo) {
            if (cargo) {
                this.assclientemaodeobra.cargo = cargo;
            } else {
                this.assclientemaodeobra.cargo = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        onFecharModal(time = 2) {
            setTimeout(() => {
                this.$emit('fecharModal', true);
            }, time * 1000 + 50);
        },
        generateId(numberId) {
            return this.$route.name + '-mao-obra-' + numberId;
        },
        valUnitUpdate(value) {
            this.assclientemaodeobra.valorunitariocusto = value;
        },
        valUnitFinalUpdate(value) {
            this.assclientemaodeobra.valorunitariofinal = value;
        },
        quantidadeUpdate(value) {
            this.assclientemaodeobra.qtde = value;
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
